import { useIdentityVerificationModal } from '../components';
import { setSessionReturnURL } from '../api/api';
const useIdentityVerification = () => {
    const { enqueueIdentityVerificationModal } = useIdentityVerificationModal();
    const requireIdentityVerification = (callback) => {
        const MFALoginDetected = window.AccountConfig.UIFlags.MFALogin;
        if (MFALoginDetected) {
            callback();
        }
        else {
            enqueueIdentityVerificationModal({
                onConfirm: async () => {
                    await setSessionReturnURL(window.location.href);
                    window.location.href = '/AccountAccess.aspx?_EC=1';
                }
            });
        }
    };
    return { requireIdentityVerification };
};
export default useIdentityVerification;
